/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Feature_3Inputs */

const en_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch for YouTube`)
};

const id_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch untuk YouTube`)
};

const ms_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch untuk YouTube`)
};

const ca_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch per YouTube`)
};

const cs_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch pro YouTube`)
};

const da_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch til YouTube`)
};

const de_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppenaufsicht für YouTube`)
};

const et_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube'i koosvaatamine`)
};

const es_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver en grupo en YouTube`)
};

const fr_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-visionnage sur YouTube`)
};

const hr_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupno gledanje za YouTube`)
};

const it_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streaming di gruppo per YouTube`)
};

const lv_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopīga YouTube skatīšanās`)
};

const lt_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bendrinamas „YouTube“ žiūrėjimas`)
};

const hu_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-videók közös megtekintése`)
};

const nl_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube kijken met anderen`)
};

const nb_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se YouTube sammen`)
};

const pl_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oglądanie grupowe YouTube`)
};

const pt_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistir em grupo ao YouTube`)
};

const ro_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch pentru YouTube`)
};

const sk_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupwatch pre YouTube`)
};

const sl_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skupinski ogled za YouTube`)
};

const fi_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTuben ryhmäkatselu`)
};

const sv_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppbevakning för YouTube`)
};

const vi_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng xem YouTube cùng cả nhóm`)
};

const tr_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube için Birlikte İzleme`)
};

const el_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ομαδική προβολή για το YouTube`)
};

const bg_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Групово гледане за YouTube`)
};

const ru_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместный просмотр для YouTube`)
};

const sr_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Групно гледање за YouTube`)
};

const uk_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Груповий перегляд для YouTube`)
};

const ka_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-ს ჯგუფური წვდომა`)
};

const hi_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूट्यूब के लिए ग्रुपवॉच `)
};

const th_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรุ๊ปวอทช์สำหรับ YouTube`)
};

const ko_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유튜브 그룹 시청`)
};

const zh_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 组队观看`)
};

const zh_tw_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 群組監控`)
};

const ja_talk_feature_3 = /** @type {(inputs: Talk_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのGroupwatch`)
};

/**
* | output |
* | --- |
* | "Groupwatch for YouTube" |
*
* @param {Talk_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_feature_3 = /** @type {((inputs?: Talk_Feature_3Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Feature_3Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_feature_3(inputs)
	if (locale === "ms") return ms_talk_feature_3(inputs)
	if (locale === "ca") return ca_talk_feature_3(inputs)
	if (locale === "cs") return cs_talk_feature_3(inputs)
	if (locale === "da") return da_talk_feature_3(inputs)
	if (locale === "de") return de_talk_feature_3(inputs)
	if (locale === "et") return et_talk_feature_3(inputs)
	if (locale === "es") return es_talk_feature_3(inputs)
	if (locale === "fr") return fr_talk_feature_3(inputs)
	if (locale === "hr") return hr_talk_feature_3(inputs)
	if (locale === "it") return it_talk_feature_3(inputs)
	if (locale === "lv") return lv_talk_feature_3(inputs)
	if (locale === "lt") return lt_talk_feature_3(inputs)
	if (locale === "hu") return hu_talk_feature_3(inputs)
	if (locale === "nl") return nl_talk_feature_3(inputs)
	if (locale === "nb") return nb_talk_feature_3(inputs)
	if (locale === "pl") return pl_talk_feature_3(inputs)
	if (locale === "pt") return pt_talk_feature_3(inputs)
	if (locale === "ro") return ro_talk_feature_3(inputs)
	if (locale === "sk") return sk_talk_feature_3(inputs)
	if (locale === "sl") return sl_talk_feature_3(inputs)
	if (locale === "fi") return fi_talk_feature_3(inputs)
	if (locale === "sv") return sv_talk_feature_3(inputs)
	if (locale === "vi") return vi_talk_feature_3(inputs)
	if (locale === "tr") return tr_talk_feature_3(inputs)
	if (locale === "el") return el_talk_feature_3(inputs)
	if (locale === "bg") return bg_talk_feature_3(inputs)
	if (locale === "ru") return ru_talk_feature_3(inputs)
	if (locale === "sr") return sr_talk_feature_3(inputs)
	if (locale === "uk") return uk_talk_feature_3(inputs)
	if (locale === "ka") return ka_talk_feature_3(inputs)
	if (locale === "hi") return hi_talk_feature_3(inputs)
	if (locale === "th") return th_talk_feature_3(inputs)
	if (locale === "ko") return ko_talk_feature_3(inputs)
	if (locale === "zh") return zh_talk_feature_3(inputs)
	if (locale === "zh-tw") return zh_tw_talk_feature_3(inputs)
	if (locale === "ja") return ja_talk_feature_3(inputs)
	return en_talk_feature_3(inputs)
});